import { ThemeOptions } from "@mui/material";
import {
  commonBorderRadius,
  generateErrorWarnInfoColors,
  MuiButton,
  MuiChip,
  styleRootCommonAppBar
} from "./util/theme-generator-util";

export const likemagicFontFamilyTitle = "Matter-SemiBold";
export const likemagicFontFamilyBody = "Matter-Regular";
declare module "@mui/material/Button" {
  interface ButtonPropsVariantOverrides {
    accent: true;
    primary: true;
    secondary: true;
    success: true;
    warning: true;
    error: true;
    disabled: true;
    standard: true;
  }
}

declare module "@mui/material/styles" {
  interface Palette {
    accent: Palette["primary"];
  }

  interface PaletteOptions {
    accent?: PaletteOptions["primary"];
  }
}

export const buttonGeneralStyle = {
  height: 48,
  fontSize: 14,
  fontWeight: 700,
  boxShadow:
    "rgb(0 0 0 / 20%) 0px 3px 1px -2px, rgb(0 0 0 / 14%) 0px 2px 2px 0px, rgb(0 0 0 / 12%) 0px 1px 5px 0px;"
};
export const likemagicBackofficeThemeConfig: ThemeOptions = {
  components: {
    MuiChip,
    MuiButton,
    MuiAppBar: {
      styleOverrides: {
        root: styleRootCommonAppBar
      }
    }
  },
  shape: {
    borderRadius: commonBorderRadius
  },
  palette: {
    primary: {
      main: "#000000"
    },
    secondary: {
      main: "#000000"
    },
    ...generateErrorWarnInfoColors(),
    background: {
      default: "#EEEEEE",
      paper: "#FFFFFF"
    },
    text: {
      primary: "#000000",
      secondary: "#9E9E9E"
    },
    action: {
      disabledOpacity: 0
    },
    grey: {
      "400": "#BDBDBD",
      "600": "#757575"
    }
  },
  typography: {
    fontFamily: likemagicFontFamilyBody,
    h1: {
      fontStyle: "normal",
      fontFamily: likemagicFontFamilyTitle,
      fontSize: "24px",
      lineHeight: "36px"
    },
    h2: {
      fontStyle: "normal",
      fontFamily: likemagicFontFamilyTitle,
      fontSize: "22px",
      lineHeight: "33px"
    },
    h3: {
      fontStyle: "normal",
      fontFamily: likemagicFontFamilyTitle,
      fontSize: "20px",
      lineHeight: "30px"
    },
    h4: {
      fontStyle: "normal",
      fontFamily: likemagicFontFamilyTitle,
      fontSize: "18px",
      lineHeight: "22px"
    },
    subtitle1: {
      fontStyle: "normal",
      fontFamily: likemagicFontFamilyBody,
      fontSize: "24px",
      lineHeight: "28px"
    },
    body1: {
      fontFamily: likemagicFontFamilyBody,
      fontStyle: "normal",
      fontSize: "16px",
      lineHeight: "24px",
      paddingBottom: "0px"
    },
    body2: {
      fontFamily: likemagicFontFamilyBody,
      fontStyle: "normal",
      fontSize: "14px",
      lineHeight: "20px",
      paddingBottom: "0px"
    }
  }
};
